import React from "react";
import { Link } from "react-router-dom";

import formatNumber from "venuescanner-js/helpers/formatNumber";
import { leadStatus } from "venuescanner-js/constants/thread";

const LeadStatusPopup = ({ lead, leadCurrency }) => {
  return (
    <div className="lead-status-popup">
      <div className="lead-status-popup__wrapper">
        {lead.venue.enquiries?.locked &&
        lead.lead.status === leadStatus.OPEN ? (
          <>
            <h3
              className={`lead-status-popup__title lead-status-popup__title--locked`}
            >
              &#9995; &nbsp; Free enquiry limit reached
            </h3>
            <p className="lead-status-popup__copy">
              {lead.venue.name} has reached its monthly free enquiry limit and
              won't be able to action this MatchLead until your next freemium
              period starts. Switch to one of our membership plans to access
              unlimited enquiries, 0% commission and a whole host of additional
              perks.
            </p>
          </>
        ) : (
          <>
            {lead.lead.status === leadStatus.INTERESTED && (
              <>
                <h3
                  className={`lead-status-popup__title lead-status-popup__title--${lead.lead.status}`}
                >
                  MatchLead pending
                </h3>
                <p className="lead-status-popup__copy">
                  The organiser has your venues details, we'll notify you if
                  they're interested in proceeding with the below event by
                  sending you an enquiry.
                </p>
              </>
            )}
            {lead.lead.status === leadStatus.EXPIRED && (
              <>
                <h3
                  className={`lead-status-popup__title lead-status-popup__title--${lead.lead.status}`}
                >
                  MatchLead expired
                </h3>
                <p className="lead-status-popup__copy">
                  Unfortunately this MatchLead has expired, be sure to check
                  your MatchLeads daily to avoid missing out on potential
                  bookings.
                </p>
              </>
            )}
            {lead.lead.status === leadStatus.ACCEPTED ||
              (lead.lead.status === leadStatus.ACCEPTED_ORGANICALLY && (
                <>
                  <h3
                    className={`lead-status-popup__title lead-status-popup__title--${lead.lead.status}`}
                  >
                    MatchLead accepted
                  </h3>
                  <p className="lead-status-popup__copy">
                    Congratulations, the organiser is interested. We have now
                    sent you an enquiry where you can continue to help the
                    organiser with their event.
                  </p>
                </>
              ))}
          </>
        )}

        <div className="lead-status-popup__info">
          <div className="lead-status-popup__info__row">
            <span className="lead-status-popup__info__row__item p">
              Event type:
            </span>
            <span className="lead-status-popup__info__row__item p">
              {lead.admin_event?.event_type || "-"}
            </span>
          </div>
          <div className="lead-status-popup__info__row">
            <span className="lead-status-popup__info__row__item p">
              Guests:
            </span>
            <span className="lead-status-popup__info__row__item p">
              {lead.admin_event.capacity}
            </span>
          </div>
          <div className="lead-status-popup__info__row">
            <span className="lead-status-popup__info__row__item p">
              Date(s):
            </span>
            <span className="lead-status-popup__info__row__item p">
              {lead.admin_event?.localise?.date?.from
                ? lead.admin_event.localise.date.from !==
                  lead.admin_event?.localise?.date?.to
                  ? lead.admin_event.localise.date.from +
                    " - " +
                    lead.admin_event.localise.date.to
                  : lead.admin_event.localise.date.from
                : "-"}
            </span>
          </div>
          <div className="lead-status-popup__info__row">
            <span className="lead-status-popup__info__row__item p">Time:</span>
            <span className="lead-status-popup__info__row__item p">
              {lead.admin_event?.localise?.time?.from
                ? lead.admin_event?.localise?.time?.from +
                  " - " +
                  lead.admin_event?.localise?.time?.to
                : "-"}
            </span>
          </div>
          <div className="lead-status-popup__info__row">
            <span className="lead-status-popup__info__row__item p">
              Budget:
            </span>
            {lead.admin_event.budget ? (
              <span className="lead-status-popup__info__row__item p">
                {leadCurrency.currency.symbol +
                  formatNumber(lead.admin_event.budget)}
              </span>
            ) : (
              <span className="lead-status-popup__info__row__item p">-</span>
            )}
          </div>
        </div>

        <div className="lead-status-popup__ctas">
          <Link to="/inbox/leads" onClick={(e) => e.stopPropagation()}>
            <button className="button button--outline-light">Go back</button>
          </Link>
          {lead.venue.enquiries?.locked &&
            lead.lead.status === leadStatus.OPEN && (
              <a href="/subscription-upgrade" target="_blank">
                <button
                  className="button button--light"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  Upgrade
                </button>
              </a>
            )}
          {lead.lead.status === leadStatus.ACCEPTED ||
            (lead.lead.status === leadStatus.ACCEPTED_ORGANICALLY && (
              <Link to="/inbox" onClick={(e) => e.stopPropagation()}>
                <button className="button button--light">View Enquiry</button>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default LeadStatusPopup;
